import * as React from "react";
import { Grid, GridColumn as Column, GridNoRecords } from "@progress/kendo-react-grid";
import { ActiveCell, SignatureCell, EditCommandCell } from "../GridComponents";
import { GridLoader } from "components/GridLoader";

const SuppliersList = ({ loading, supplierCategories, enterEdit }) => {
  const MyEditCommandCell = (props) => (
    <EditCommandCell {...props} enterEdit={enterEdit} />
  );

  return (
    <div className="settings-grid h-100">
      <Grid
        data={supplierCategories}
        showLoader={loading}
        loader={
          <div style={{ height: "50px" }}>
            <GridLoader />
          </div>
        }
        style={{ height: "100%" }}
      >
        <GridNoRecords>
          {loading ? (
            <span></span>
          ) : (
            supplierCategories && supplierCategories?.length === 0 && "No records available"
          )}
        </GridNoRecords>
        <Column
          title=" "
          width="80"
          field="categoryName"
          cell={(props) => <SignatureCell {...props} />}
        />
        <Column field="categoryName" title="Category Name" />
        <Column field="active" title="Active" width="80" cell={ActiveCell} />
        <Column title="Edit" width="80" cell={MyEditCommandCell} />
      </Grid>
    </div>
  );
};

export default SuppliersList;
